module.exports = __webpack_public_path__ + "static/media/buy_req_teach_11.81ca7fa9.jpg";